export default function Logo() {
  return (
    <img
      src="poze/deltasupportlogo.svg"
      alt="deltasupportlogo"
      className="logo"
    />
  );
}
